import { ImgOk } from '../../img';
const StepFinish = () => {

    const reload = () => window.location.reload();

    return (
        <div className="step-finisth-ihcr-aec">
            <div className="img-ih-cr-aec pt-50">
                < ImgOk />
            </div>
            <p className='center pt-20' style={{ color: '#ffffff', fontSize: 20, fontWeight: 600 }}>¡Todo listo!</p>
            <p className='center' style={{ color: '#ffffff' }}>Hemos recibido tus datos</p>

            <p className='center mt-50' style={{ color: '#ffffff' }}>Uno de nuestros ejecutivos te <br /> contactará lo más pronto posible.</p>
            <p className='center mt-10' style={{ color: '#ffffff' }}>Si desea información adicional puede <br />  ponerse en contacto al</p>

            <p className='center' style={{ color: '#ffffff', fontWeight: 600 }}>+506 2246-2700 <br /> +506 6094-7218</p>
            <div onClick={() => reload()}>
                <p className='center pt-50 mb-50 pb-50' style={{ color: '#ffffff' }} >Volver al sitio web</p>
            </div>
        </div>
    )
}

export { StepFinish }